import { Content } from "@/components/Content";
import { createTitle } from "@/functions/createTitle";
import * as additionalComponents from "./__components";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  return {
    props: {
      meta: {
        title: createTitle("Submission Complete"),
      },
      content: [
        { component: "Banner", props: { className: "" } },
        { component: "Text", props: { className: "", content: { path: "page.form.complete.text" } } },
      ],
    },
  };
}
